import { CAR_BATTERY_VEHICLE_TYPE_ID, MOTOR_BATTERY_VEHICLE_TYPE_ID, vehicleTypeBatteryTitle } from '@/constants/batteryProduct';
import { batteryRequest, checkoutCartPage } from '@/constants/routes';

import { inspectionVehicleTitle } from '../inspection';

export const sourceTypeRequestRoute = {
    all: checkoutCartPage,
    battery: batteryRequest
};

export const productRequestRouteByVehicleType = {
    [CAR_BATTERY_VEHICLE_TYPE_ID]: batteryRequest,
    [MOTOR_BATTERY_VEHICLE_TYPE_ID]: batteryRequest
} as const;

export const RELATED_PRODUCTS_SECTION_ID = 'related-products';

export const vehicleTitleByVehicleType = {
    ...vehicleTypeBatteryTitle,
    ...inspectionVehicleTitle
} as const;
